module.exports = __webpack_public_path__ + "media/images/area/feature/banner/en/sp/en_kyushu-185f41ade1e3c67f7fead5bf477a5211.png";